/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/hi_IN';
import DatePicker from './date-picker/hi_IN';
import Pagination from './pagination/hi_IN';
import TimePicker from './time-picker/hi_IN';

export default {
  locale: 'hi',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  // locales for all comoponents
  global: {
    placeholder: 'à¤à¥à¤ªà¤¯à¤¾ à¤à¥à¤¨à¥à¤'
  },
  Table: {
    filterTitle: 'à¤¸à¥à¤à¥ à¤¬à¤à¤¦ à¤à¤°à¥à¤',
    filterConfirm: 'à¤à¤à¥à¤à¥ à¤¤à¤°à¤¹ à¤¸à¥',
    filterReset: 'à¤°à¥à¤¸à¥à¤',
    emptyText: 'à¤à¥à¤ à¤à¤¾à¤¨à¤à¤¾à¤°à¥ à¤¨à¤¹à¥à¤',
    selectAll: 'à¤µà¤°à¥à¤¤à¤®à¤¾à¤¨ à¤ªà¥à¤·à¥à¤  à¤à¤¾ à¤à¤¯à¤¨ à¤à¤°à¥à¤',
    selectInvert: 'à¤µà¤°à¥à¤¤à¤®à¤¾à¤¨ à¤ªà¥à¤·à¥à¤  à¤à¥à¤®à¤¾à¤à¤',
    sortTitle: 'à¤¦à¥à¤µà¤¾à¤°à¤¾ à¤à¥à¤°à¤®à¤¬à¤¦à¥à¤§ à¤à¤°à¥à¤'
  },
  Modal: {
    okText: 'à¤à¤à¥à¤à¥ à¤¤à¤°à¤¹ à¤¸à¥',
    cancelText: 'à¤°à¤¦à¥à¤¦ à¤à¤°à¤¨à¤¾',
    justOkText: 'à¤à¤à¥à¤à¥ à¤¤à¤°à¤¹ à¤¸à¥'
  },
  Popconfirm: {
    okText: 'à¤à¤à¥à¤à¥ à¤¤à¤°à¤¹ à¤¸à¥',
    cancelText: 'à¤°à¤¦à¥à¤¦ à¤à¤°à¤¨à¤¾'
  },
  Transfer: {
    titles: ['', ''],
    notFoundContent: 'à¤¨à¤¹à¥à¤ à¤®à¤¿à¤²à¤¾',
    searchPlaceholder: 'à¤¯à¤¹à¤¾à¤ à¤à¥à¤à¥à¤',
    itemUnit: 'à¤¤à¤¤à¥à¤¤à¥à¤µ',
    itemsUnit: 'à¤µà¤¿à¤·à¤¯-à¤µà¤¸à¥à¤¤à¥'
  },
  Select: {
    notFoundContent: 'à¤¨à¤¹à¥à¤ à¤®à¤¿à¤²à¤¾'
  },
  Upload: {
    uploading: 'à¤à¤ªà¤²à¥à¤¡à¤¿à¤à¤...',
    removeFile: 'à¤«à¤¼à¤¾à¤à¤² à¤¨à¤¿à¤à¤¾à¤²à¥à¤',
    uploadError: 'à¤à¤ªà¤²à¥à¤¡ à¤®à¥à¤ à¤¤à¥à¤°à¥à¤à¤¿',
    previewFile: 'à¤«à¤¼à¤¾à¤à¤² à¤ªà¥à¤°à¥à¤µà¤¾à¤µà¤²à¥à¤à¤¨'
  }
};
